import React, { Component } from 'react'
import { graphql } from 'gatsby'
import styled, { css } from 'styled-components'
import Img from 'gatsby-image'
import axios from 'axios'
import {
  Row,
  Col,
  Gap,
  Text,
  Section,
  Title,
  Button,
  VH,
  SEO,
  TextField,
} from '../components'
import { up } from '../lib/styles'
import Link from '../components/Link'
import links from '../lib/links'

const DownloadLink = styled.a`
  text-transform: uppercase;
  color: white;
  font-size: 20px;
  font-weight: 700;
  background: #007ef9;
  display: block;
  cursor: pointer;
  padding: 16px 20px;
  border: 1px solid #006cd3;

  transition: 0.2s;
  &:hover {
    background: #006cd3;
  }

  ${up('mobile')} {
    font-size: 24px;
    padding: 20px 24px;
  }
`

const CONTENT_WIDTH = '1700px'
// const CONTENT_WIDTH = '1435px'

class Vr extends Component {
  render() {
    const {
      location: { pathname },
      data: { vrImage1, vrImage2 },
    } = this.props

    return (
      <>
        <Gap.Top />
        <Gap gap="140px" mobileGap="40px" />
        <SEO
          title="Zuri 2.0 VR Flight Experience"
          description="Step inside Zuri’s 2.0 VR simulator. Experience hybrid VTOL flight at home or live events for a fully immersive experience."
          pathname={pathname}
        />
        <Section background="black" width={CONTENT_WIDTH}>
          <Title.Big
            innerAs="h1"
            fontWeight="400"
            white
            black={false}
            uppercase
            textAlign="center"
          >
            Experience Zuri 2.0 in Virtual Reality
          </Title.Big>

          <Gap gap="40px" mobileGap="40px" />
        </Section>

        <Gap gap="32px" mobileGap="24px" />
        <Img
          fluid={vrImage1.image.fluid}
          alt="Woman using Meta Quest VR headset to experience the interior and flight simulation of Zuri 2.0 hybrid VTOL aircraft inside a hangar."
          loading="eager"
        />
        <Gap gap="80px" mobileGap="40px" />

        <Section background="black" width={CONTENT_WIDTH}>
          <Title.Medium
            innerAs="h2"
            textColor="white"
            style={{ textTransform: 'uppercase' }}
          >
            Zuri 2.0 VR at Home with Meta Quest
          </Title.Medium>
          <Gap gap="24px" mobileGap="24px" />
          <Text fontWeight="400" style={{ color: 'white', maxWidth: '770px' }}>
            Experience the Zuri 2.0 VR Simulator in your living room with your
            Meta Quest. Step inside a Hybrid VTOL aircraft, move around its
            interior and exterior, and explore cutting-edge regional air
            mobility technology. Get a close-up view of Zuri's innovative design
            and flight features, all in full-size VR.
          </Text>
          <Gap gap="40px" mobileGap="40px" />
        </Section>

        <Section background="black" width={CONTENT_WIDTH}>
          <Row>
            <Col alignItems="center">
              <Row>
                <DownloadLink
                  href="https://www.meta.com/experiences/7485815678101871/"
                  target="_blank"
                >
                  Download here using your meta quest
                </DownloadLink>
              </Row>
              <Gap gap="20px" mobileGap="20px" />

              <Text.Small fontSize="16px" style={{ color: 'white' }}>
                Requires Meta Quest 2 or better. Meta Quest 3 is recommended.
              </Text.Small>
            </Col>
          </Row>

          <Gap gap="84px" mobileGap="60px" />
        </Section>

        {/* <Gap gap="32px" mobileGap="24px" /> */}
        <Img
          fluid={vrImage2.image.fluid}
          alt="Visitors experience Zuri’s 5-person VR flight simulator at the AERO Conference, showcasing the capabilities of hybrid VTOL aircraft with one pilot in control and four passengers onboard."
        />
        <Gap gap="80px" mobileGap="32px" />

        <Section background="black" width={CONTENT_WIDTH}>
          <Title.Medium
            innerAs="h2"
            textColor="white"
            style={{ textTransform: 'uppercase' }}
          >
            Zuri 5-Person VR Flight Simulator
          </Title.Medium>
          <Gap gap="24px" mobileGap="24px" />
          <Text fontWeight="400" style={{ color: 'white', maxWidth: '770px' }}>
            At live events like Aero 2023, experience Zuri’s 5-person VR flight
            simulator. One pilot controls the Hybrid VTOL aircraft using a VR
            headset, while four additional passengers enjoy the flight in
            real-time. This immersive experience showcases the potential of
            hybrid VTOL technology and provides a hands-on look at the future of
            regional air mobility.
          </Text>
          <Gap gap="80px" mobileGap="40px" />
        </Section>
      </>
    )
  }
}

export default Vr

export const pageQuery = graphql`
  query {
    vrImage1: file(
      relativePath: {
        eq: "images/vr/zuri-2-vr-simulator-meta-quest-home-experience.jpg"
      }
    ) {
      ...FullHdImage
    }
    vrImage2: file(
      relativePath: {
        eq: "images/vr/zuri-5-person-vr-flight-simulator-aero-friedrichshafen.jpg"
      }
    ) {
      ...FullHdImage
    }
  }
`
